function FeaturedExpertise(){

    var size = new BrowserSize();

    var s = size.getWindowSize();

    $( window ).resize(function() {
        s = size.getWindowSize();
    });


    $('#f-8').click(function(e) {

        e.preventDefault();

        $('#contact-modal').modal('show')

    });


    $('.featured-data').each(function(index, element){


        $(this)
            .mouseover(function() {

                var self = this;

                if (s.width > 1199) {

                    if (index !== 8) {

                        console.log("mouse over " + index);

                        var t = "#t-" + index;

                        TweenMax.to(t, 0.4, {top: 0});


                    } else {

                        var f = "#f-" + index;

                        TweenMax.to(f, 0.4, {autoAlpha: 0.9});

                    }

                }

            })
            .mouseout(function() {

                var self = this;

                if (s.width > 1199) {

                    if (index !== 8) {

                        console.log("mouse out " + index);

                        var t = "#t-" + index;

                        TweenMax.to(t, 0.4, {top: "100%"});

                    } else {

                        var f = "#f-" + index;

                        TweenMax.to(f, 0.4, {autoAlpha: 1});

                    }
                }


            });


    });

}
